export default class OtrForm {
  validate() {
    $('#dmv_otr_form').formValidation({
      framework: 'bootstrap',
      icon: {
        valid: 'icon icon-success',
        invalid: 'icon icon-danger',
        validating: 'fa fa-refresh',
      },
      fields: {
        first_name: {
          validators: {
            notEmpty: {
              message: 'The first name is required',
            },
          },
        },
        last_name: {
          validators: {
            notEmpty: {
              message: 'The last name is required',
            },
          },
        },
        phone: {
          validators: {
            notEmpty: {
              message: 'The phone number is required',
            },
          },
        },
        email: {
          validators: {
            notEmpty: {
              message: 'The email is required',
            },
            emailAddress: {
              message: 'You must use a valid email address',
            },
          },
        },
        reason: {
          validators: {
            notEmpty: {
              message: 'Select an option',
            },
          },
        },
        state: {
          validators: {
            notEmpty: {
              message: 'Select a state',
            },
          },
        },
        fine: {
          validators: {
            notEmpty: {
              message: 'The amount of the fine is required',
            },
            numeric: {
              options: {
                thousandsSeparator: '',
                decimalSeparator: '.',
                message: 'The value is not a valid numeric number',
              },
            },
          },
        },
      },
    }).on('success.form.fv', function () {
      this.submit();
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/plugins/dmv-lawyers/otr-form.js